import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams ,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import {ApplicationVariables, AppConfig} from './config';
import { TokenManager } from './token-manager' ;
import { GVLogger } from '../services/gv-logger';
import { ApiOffline } from "./api-offline";
import { Storage } from '@ionic/storage';
import {NavController ,ToastController} from 'ionic-angular';
import {Settings} from "./settings";
import {CommonDataProvider} from "./common-data/common-data";
import {BehaviorSubject} from 'rxjs';
import {CartManager} from './cart-manager';
import { RoutingInfo} from './data';
import { loginUserInfo} from './data';



@Injectable()
export class Api {
  rtApiURL: string = "";
  dtApiURL: string =  "";

  private isFirstLogin = new BehaviorSubject(null);
  getIfFirstLogin = this.isFirstLogin .asObservable();
  nodeServiceUrl: any = "";
  private imageUploaderUrl = ""


  constructor(public http: Http,
    private tokenManager:TokenManager,
    private gVLogger:GVLogger,
    private apiOffline:ApiOffline,
    private storage:Storage,
    private toastCtrl:ToastController,
    public commonDataProvider:CommonDataProvider,
    public cartManager : CartManager
    // public settings:Settings
  ) {


    console.log("RRRRRRRRRRRRRRRRRRRRRRRRRR " + RoutingInfo.imageUploaderUrl)


  }

  setURL(){
    let url = RoutingInfo;
    this.dtApiURL =  url.dt + "api/v1";
    this.rtApiURL =  url.rt + "api/v2";
    this.imageUploaderUrl = RoutingInfo.imageUploaderUrl + "/api/v1";
    // this.imageUploaderUrl = "http://localhost:8083" + "/api/v1";
  }

  get(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }
    this.storage.get('countryCode').then();
      return this.http.get(this.rtApiURL + '/' + endpoint, options);

  }

  userAvailabilityRA(endpoint: string, body: any, reqOpts?: any){

    return this.http.post(AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"] + '/' + endpoint, reqOpts,{ params: body});
}

  post(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
    return this.http.post(this.rtApiURL + '/' + endpoint, body, options);

  }

  imageUploaderPost(endpoint: string, body: any, docModuleId, docModule, countryAbbrivation, sourceUuid) {
    this.setURL();
    let headers = new Headers({
      'token':this.tokenManager.getToken(),
      'docModuleId' : docModuleId,
      'docModule' : docModule,
      'countryAbbrivation' : countryAbbrivation,
      'sourceUuid' : sourceUuid,
      'parentInventoryLocationId' : loginUserInfo.assignedWarehouseId
    });

    let options = new RequestOptions({
      headers: headers,
    });


    return this.http.post(this.imageUploaderUrl + endpoint, body, options);

  }

  postADPPay(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let url = RoutingInfo;
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
    return this.http.post(RoutingInfo.billingUrl + endpoint, body, options);

  }

  getADPPay(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }

    this.storage.get('countryCode').then();
      // return this.http.get(AppConfig[AppConfig.ENVIRONMENT+"_ApiURL_billing"] + '/' + endpoint, options);
      return this.http.get(RoutingInfo.billingUrl + '/' + endpoint, options);

  }

  postRA(endpoint: string, body: any, options?: RequestOptions) {
    let url = AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"];
    this.gVLogger.log("uuuuurrrlll" + url);
    // let url = AppConfig.LOCAL_RA_SERVICE;

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    options = new RequestOptions({
      headers: headers
    });
    return this.http.post(url + endpoint, body, options);
  }

  getRA(endpoint: string, options?: RequestOptions) {
    let url = AppConfig[AppConfig.ENVIRONMENT+"_RA_SERVICE"];
    this.gVLogger.log("uuuuurrrlll" + url);
    // let url = AppConfig.LOCAL_RA_SERVICE;

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    options = new RequestOptions({
      headers: headers
    });
    return this.http.get(url + endpoint, options);
  }

  postJazzba(endpoint: string, body: any, options?: RequestOptions) {

    let headers = new Headers({
      'Content-Type': 'application/json',
      'token':this.tokenManager.getToken()
      });


    if(endpoint !="users/auth"){
       options = new RequestOptions({
        headers: headers
      });
    }
    return this.http.post(this.nodeServiceUrl + '/' + endpoint, body, options);
  }

  setIfFirstLogin(firstLoginState:boolean){
    this.isFirstLogin.next(firstLoginState)
    }

  geJazzba(endpoint: string, params?: any, options?: RequestOptions){
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }
      return this.http.get(this.dtApiURL + '/' + endpoint, options);

  }

  postlocal(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    let headers = new Headers({
      'Content-Type': 'application/json',
      'token': this.tokenManager.getToken()
    });


    if (endpoint != "users/auth") {
      options = new RequestOptions({
        headers: headers
      });
      return this.http.post(this.dtApiURL + '/' + endpoint, body, options);
    }
  }

  getlocal(endpoint: string, params?: any, options?: RequestOptions) {
    this.setURL();
    if (!options) {
      options = new RequestOptions();
    }
    this.gVLogger.log(this.tokenManager.getToken());
    let headers = new Headers({ 'token': this.tokenManager.getToken()});
    options = new RequestOptions({ headers: headers });
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }
      return this.http.get(this.dtApiURL + '/' + endpoint, options);

  }

  put(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.put(this.rtApiURL + '/' + endpoint, body, options);
  }

  deletePost(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.post(this.rtApiURL + '/' + endpoint, body, options);
  }

  patch(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.put(this.rtApiURL + '/' + endpoint, body, options);
  }

  delete(endpoint: string, body: any, options?: RequestOptions) {
    this.setURL();
    return this.http.delete(this.rtApiURL + '/' + endpoint, options);
  }

  static nFormatter(num) {
    if(num == null){
      num = 0;
    }
    let digits = 1;
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "B" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "k" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }

    var ret = num.toFixed(digits).replace(rx, "$1");

    if(isNaN(ret)){
      ret = 0;
    }

    return ret;


  }

  urlAvailable(endpoint){
    if(ApplicationVariables.isOffline && endpoint.indexOf("customers/searchAll")!== -1){
      return true;
    }else{
      return false;
    }
  }

  toastMSG(msg){

    let t = this.toastCtrl.create({
      message:msg,
      duration:2000,
      position: 'bottom'
    });
    t.present();

  }



  getFullUrl(url: string, params?: any, options?: RequestOptions) {
    if (!options) {
      options = new RequestOptions();
    }
    // Support easy query params for GET requests
    if (params) {
      let p = new URLSearchParams();
      for(let k in params) {
        p.set(k, params[k]);
      }
      // Set the search field if we have params and don't already have
      // a search field set in options.
      options.search = !options.search && p || options.search;
    }


    this.gVLogger.log(options);

 //   if(this.urlAvailable(endpoint)){
 //     return this.apiOffline.get(endpoint, options);
  //  }else{
      return this.http.get(url, options);
  //  }
 }

//  toastMsg(msg,action){
//   this.snackBar.open(msg, action, {
//       duration: 3500
//   });
// }


}



// WEBPACK FOOTER //
// ./src/providers/api.ts